const permissionConstants = {
  GENERATE_USERNAME_PASSWORD: 'GENERATE_USERNAME/PASSWORD',
  CRITERIA: 'CRITERIA',
  PERSONAL_LOAN_PRODUCT: 'PERSONAL_LOAN_PRODUCT',
  PIA: 'PIA',
  APPROVED_APPLICATION: 'APPROVED_APPLICATION',
  WORK_BASKET: 'WORK_BASKET',
  ENQUIRY: 'ENQUIRY',
  APPROVED_INBOX: 'APPROVED_INBOX',
  PRODUCT_SETUP: 'PRODUCT_SETUP',
  OFFER: 'OFFER',
  EMPLOYER_PREFERENCES: 'EMPLOYER_PREFERENCES',
  PRODUCT_FILTER: 'PRODUCT_FILTER',
  MANUAL_QUEUE: 'MANUAL_QUEUE',
  APPLICATION: 'APPLICATION',
  CVP: 'CVP',
  DASHBOARD: 'DASHBOARD',
  LOGIN: 'LOGIN',
  CHAT_BOT: 'CHAT_BOT',
  API_SERVICE_INTEGRATION: 'API_SERVICE_&_INTEGRATION',
  SUITABILITY_FILTER: 'SUITABILITY_FILTER',
  PRODUCT: 'PRODUCT',
  USERS_MANAGEMENT: 'USERS_MANAGEMENT',
  NOTIFICATION: 'NOTIFICATION',
  CREDIT_PREFERENCES: 'CREDIT_PREFERENCES',
  HOME_PAGE: 'HOME_PAGE',
  PIA_GENERAL_TC: 'PIA_GENERAL_TC',
  CHATBOT: 'CHATBOT',
  ACCOUNT_PROFILE: 'ACCOUNT_PROFILE',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  LOCATION_ACCESS: 'LOCATION_ACCESS',
  USER_PROFILE: 'USER_PROFILE',
  EMAIL_TEMPLATE: 'EMAIL_TEMPLATE',
  KYC_PREFERENCES: 'KYC_PREFERENCES',
  EMAIL_NOTIFICATION: 'EMAIL_NOTIFICATION',
};
export const detailPermission = {
  VIEW_DETAIL_OF_USER: 'VIEW_DETAIL_OF_USER',
  VIEW_LIST_OF_ET: 'VIEW_LIST_OF_ET',
  CREATE_PRODUCT_FILTER: 'CREATE_PRODUCT_FILTER',
  UPDATE_CREDIT_PREFERENCES: 'UPDATE_CREDIT_PREFERENCES',
  UPLOAD_FILE_CONTAINING_EMPLOYER: 'UPLOAD_FILE_CONTAINING_EMPLOYER',
  CREATE_CREDIT_PREFERENCE: 'CREATE_CREDIT_PREFERENCE',
  VIEW_DETAILS_OF_APPLICATIONS: 'VIEW_DETAILS_OF_APPLICATIONS',
  MANUAL_QUEUE_3: 'MANUAL_QUEUE_3',
  DOWNLOAD_APPLICATION_DETAILS: 'DOWNLOAD_APPLICATION_DETAILS',
  DOWNLOAD_APPLICATION_RELATED_IMAGES_AND_DOCUMENTS:
    'DOWNLOAD_APPLICATION_RELATED_IMAGES_AND_DOCUMENTS',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  CREATE_KYC_PREFERENCES: 'CREATE_KYC_PREFERENCES',
  UPDATE_PIA_GENERAL_TC: 'UPDATE_PIA_GENERAL_TC',
  VIEW_KYC_PREFERENCES: 'VIEW_KYC_PREFERENCES',
  DOWNLOAD_EMPLOYER_FILE_TEMPLATE: 'DOWNLOAD_EMPLOYER_FILE_TEMPLATE',
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  VIEW_LIST_OF_USER: 'VIEW_LIST_OF_USER',
  LIST_APPLICATION: 'LIST_APPLICATION',
  CREATE_A_USER_ROLE: 'CREATE_A_USER_ROLE',
  MANUAL_QUEUE_2: 'MANUAL_QUEUE_2',
  VIEW_PRODUCT_DETAIL: 'VIEW_PRODUCT_DETAIL',
  CREATE_A_QUESTION: 'CREATE_A_QUESTION',
  VIEW_LIST_OF_QUESTIONS: 'VIEW_LIST_OF_QUESTIONS',
  MANUAL_QUEUE_1: 'MANUAL_QUEUE_1',
  APPLICATION_DETAIL: 'APPLICATION_DETAIL',
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  VIEW_HISTORY_OF_PIA_GENERAL_TC: 'VIEW_HISTORY_OF_PIA_GENERAL_TC',
  UPDATE_ET: 'UPDATE_ET',
  VIEW_LIST_OF_USER_ROLE: 'VIEW_LIST_OF_USER_ROLE',
  UPDATE_KYC_PREFERENCES: 'UPDATE_KYC_PREFERENCES',
  VIEW_PRODUCT_FILTER: 'VIEW_PRODUCT_FILTER',
  VIEW_DETAILS_OF_PIA_GENERAL_TC: 'VIEW_DETAILS_OF_PIA_GENERAL_TC',
  CREATE_INTERNAL_USER: 'CREATE_INTERNAL_USER',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  PRODUCT_LIST: 'PRODUCT_LIST',
  UPDATE_EMPLOYER_PREFERENCES: 'UPDATE_EMPLOYER_PREFERENCES',
};
export default permissionConstants;
